import React from "react";
import {Panel, PanelBody} from "./../components/panel/panel.jsx";
import {Api} from "./../app-controller.js";
import Swal from "sweetalert2";

class Demogrid extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};

    }

    componentDidMount() {

        let grid = {
            source: "app/getRegenteApplications",
            target: "#myGrid",
            tableClass: "table table-striped m-b-0 table-hover",
            rowsPerPage: [
                5, 10, 25, 50, 100
            ],
            progressText: "Cargando datos",
            rows: {
                solicitud: {
                    label: "La solicitud",
                    render: me => {
                        me.innerHTML = `<button id="esteboton" class="btn btn-primary">${me
                            .data
                            .solicitud}</button><hr/>${me
                            .data
                            .fecha_solicitud}`
                            me
                            .querySelector("#esteboton")
                            .addEventListener("click", () => {
                                
                            });
                    }
                },
                nombre: {
                    label: "EL Nombre",
                    render: me => {
                        me.innerHTML = me.data.nombre + " " + me.data.folio
                    }
                },
                tipo: {
                    label: "Tipo regente",
                    width: "120px",
                    render: me => {
                        me.classList = "btn-warning";

                        me.addEventListener("click", () => {
                            if (me.classList === "btn-warning") {
                                me.classList = "btn-success";
                            } else {
                                me.classList = "btn-warning";
                            }
                        });
                    }
                },
                estatus: {
                    label: "Estado"
                }
            },
            rowClick: data => {
                Api.notify("Seleccionaste " + data.nombre);
                

                //busqueda.process
            },
            buttons: [
                {
                    name: "abrir",
                    btnClass: "btn bg-gradient-green",
                    iconClass: "fas fa-money-check-alt",
                    btnClick: data => {
                        

                        if (data.nombre === "Marisol Espinoza Esparza") {
                            Swal.fire({icon: "error", title: data.nombre, text: data.estatus});
                        }

                    },
                    render: (me, data) => {

                        if (data.solicitud === "Baja") {
                            me.remove();
                        }

                        if (data.nombre === "Celeste Garcia Espinoza") {
                            me.classList = "btn bg-gradient-blue";
                        }

                        if (data.nombre === "Patricia Quiroz Reyes") {
                            me.addEventListener("click", r => {
                                Swal.fire({icon: "success", title: data.estatus, text: data.tipo});
                            })
                        }
                    }
                }, {
                    // name:"cerrar", <-- Sin nombre puro icono
                    btnClass: "btn bg-gradient-red",
                    iconClass: "fas fa-folder-open",
                    btnClick: data => {
                        
                    },
                    render: (me, data) => {
                        if (data.solicitud === "Alta") {
                            me.remove();
                        }

                        if (data.nombre === "manuel lopez obrador") {
                            me.setAttribute("disabled", 1);
                        }
                    }
                }
            ]
        }

        let mi_grid = Api.grid(grid);

        /* GRID2 DEMO */
        let grid2 = {
            source: "app/getRegenteApplications", //El controlador a consumir
            target: "#myGrid2", // El elemento donde lo voy injectar
            tableClass: "table table-striped m-b-0 table-hover", //las clases de estilo de la tabla
            progressText: "Cargando Regentes Chilos", //El mensaje de carga
            hidePager: true, //Oculta el paginador
            rowClick: data => { // Evento al hacer click en un renglon
                
                /*
            formix.querySelector("#nombre").value=data.nombre;
            formix.querySelector("#tipo").value=data.tipo;
            */
                formix.merge(data); // Alimentamos la forma con el dataset (data)

            },
            rows: {
                nombre: {
                    label: "Nombre del regente"
                },
                tipo: {
                    label: "Solicitud"
                }
            }
        }

        Api.grid(grid2);
        /* FINALIZA GRID2 */

        let forma = {
            target: "#forma", // Donde queremos la forma
            disabled: false, //Bloqueamos la forma
            name: "formatica",
            onchange: (e, data, serial) => {
                if (e.name === "chk") {
                    
                    
                }
            },
            render: formita => {
                /* Cargamos el combo de tipos regentes */
                let options = "";
                let tipos = Api.loadCatalogue("cat_tipo_regente");
                options += `<option style="background:black;color:white"  value="">Seleccione</option>`;
                for (let tipo in tipos) {
                    options += `<option style="background:black;color:white" 
                          value="${tipos[tipo]
                        .descripcion}" >
                                 ${tipos[tipo]
                        .descripcion}
                          </option>`;
                }
                formita
                    .querySelector("#tipo")
                    .innerHTML = options;

                /* Fin */
            },

            elementClass: "form-control", //la clase de estilos de los elementos
            elements: [
                {
                    input: {
                        type: "hidden",
                        name: "id"
                    }
                }, {
                    fieldset: {
                        cols: 12,
                        name: "topPanel",
                        class: "btn-primary",
                        label: "Panel de arriba!",
                        content: "Cargando...",
                        render: me => {
                            setTimeout(() => {
                                me.classList = "btn-warning";
                                me.setContent("Soy bien cool", "Asi es man lo eres!");
                            }, 3000);
                        }
                    }
                }, {
                    fieldset: {
                        cols: 3,
                        name: "checks",
                        class: "btn-light",
                        label: "hola",
                        content: "Soy definido",
                        disabled:false,
                        render: me => {

                            let tpl = "";
                            for (let x = 0; x <= 1; x++) {
                                tpl += `<input class="chkx" name="chk" value=${x} checked type="checkbox"> Checks ${x} <br />`;
                            }
                            me.setContent("hola",tpl);

                        }
                    }
                }, {
                    input: {
                        type: "text",
                        name: "nombre",
                        label: "Ingresa el nombre del regente",
                        placeHolder: "Nombre completo",
                        cols: 4
                    }
                }, {
                    select: {
                        name: "tipo",
                        label: "Tipo Regente",
                        placeHolder: "ingresa datos",
                        cols: 4
                    }
                }, {
                    input: {
                        type: "text",
                        name: "folio",
                        label: "Folio",
                        placeHolder: "Ingresa el folio",
                        cols: 3,
                        value: "",
                        disabled: true
                    }
                }, {
                    input: {
                        type: "datetime-local",
                        name: "fecha_solicitud",
                        label: "Fecha",
                        placeHolder: "Ingresa la fecha",
                        cols: 3,
                        value: ""
                    }
                }, {
                    input: {
                        type: "text",
                        name: "estatus",
                        label: "Estado",
                        placeHolder: "Ingresa el estado",
                        cols: 3,
                        value: ""

                    }
                }, {
                    textarea: {
                        name: "solicitud",
                        label: "Para mostrar formato",
                        placeHolder: "un formato",
                        cols: 12,
                        value: ""
                    }
                }, {
                    button: {
                        name: "procesa",
                        class: "form-control btn btn-lg btn-primary",
                        cols: 12,
                        label: "hola tu procesa mi forma",
                        text: "Procesar",
                        icon: "fas fa-money-check-alt",
                        click: (me, data) => {
                            
                            
                            
                            Api.notify("hola tu, hiciste click!");
                            
                        }
                    }
                }
            ]
        }

        let formix = Api.form(forma);

         let busqueda = Api.form({
            target: "#busqueda",
            onchange: (me, data, serial) => {
                mi_grid.go(1, serial);
            },

            render: form => {

                /* Cargamos el combo de tipos regentes */
                let options = "";
                let tipos = Api.loadCatalogue("cat_tipo_regente");
                options += `<option style="background:black;color:white"  value="">Seleccione</option>`;
                for (let tipo in tipos) {
                    options += `<option style="background:black;color:white" 
                            value="${tipos[tipo]
                        .descripcion}" >
                                   ${tipos[tipo]
                        .descripcion}
                            </option>`;
                }
                form
                    .querySelector("#tipo")
                    .innerHTML = options;
                /* Fin */

                options = "";
                let tramites = Api.loadCatalogue("cat_estatus_tramite");
                options += `<option style="background:black;color:white"  value="">Seleccione</option>`;
                for (let tramite in tramites) {
                    options += `<option style="background:black;color:white" 
                            value="${tramites[tramite]
                        .descripcion}" >
                                   ${tramites[tramite]
                        .descripcion}
                            </option>`;
                }
                form
                    .querySelector("#estatus")
                    .innerHTML = options;

                options = "";
                let acciones = Api.loadCatalogue("cat_accion");
                options += `<option style="background:black;color:white"  value="">Seleccione</option>`;
                for (let accion in acciones) {
                    options += `<option style="background:black;color:white" 
                            value="${acciones[accion]
                        .descripcion}" >
                                   ${acciones[accion]
                        .descripcion}
                            </option>`;
                }
                form
                    .querySelector("#solicitud")
                    .innerHTML = options;

            },
            elementClass: "form-control",
            elements: [
                {
                    input: {
                        type: "text",
                        name: "nombre",
                        label: "Ingresa el nombre",
                        placeHolder: "Nombre completo",
                        cols: 4,
                        value: ""
                    }
                }, {
                    select: {
                        name: "tipo",
                        label: "Tipo Regente",
                        placeHolder: "ingresa datos",
                        cols: 4,
                        values: [
                            {
                                value: "lala",
                                option: "hola lala"
                            }
                        ]
                    }
                }, {
                    input: {
                        type: "text",
                        name: "folio",
                        label: "Folio",
                        placeHolder: "Ingresa el folio",
                        cols: 2,
                        value: ""
                    }
                }, {
                    input: {
                        type: "datetime-local",
                        name: "fecha_solicitud",
                        label: "Fecha",
                        placeHolder: "Ingresa la fecha",
                        cols: 2,
                        value: ""
                    }
                }, {
                    select: {
                        name: "estatus",
                        label: "Estado",
                        cols: 2
                    }
                }, {
                    select: {
                        name: "solicitud",
                        label: "Tipo Solicitud",
                        cols: 2
                    }
                }
            ]
        });

    }

    render() {
        return (
            <Panel>
                <PanelBody>
                    <div className="row">
                        <div className="col-sm-4" id="myGrid2"></div>
                        <fieldset className="col-sm-8">
                            <legend>Detalle de regente</legend>
                            <div id="forma"></div>
                        </fieldset>
                        <div className="col-sm-12">
                            <fieldset>
                                <legend>Buscar Regente</legend>
                                <div id="busqueda"></div>
                            </fieldset>

                            <div id="myGrid"></div>
                        </div>
                    </div>

                </PanelBody>
            </Panel>
        );
    }

}

export default Demogrid;
